import { Flex } from "antd";
import Icon, { ICON_NAME } from "../../Icon";

interface IProps {
    name: string;
    onClick: () => void;
    sticky?: boolean;
}

export default function NextTabButton({ name, onClick, sticky = false }: IProps) {
    const button = (
        <Flex className="cursor-pointer" align="center" gap={2} onClick={onClick}>
            <div className="link">
                {name}
            </div>
            <Icon icon={ICON_NAME.ARROW_RIGHT_3} bg="colorLink" className="mt-[1px]" />
        </Flex>
    );

    if (sticky) {
        return (
            <div className="sticky bottom-[60px] z-10 flex justify-end min-h-[50px] items-center">
                {button}
            </div>
        );
    }

    return <>
        <div className="min-h-[20px] flex-1" />
        <div className="flex justify-end min-h-[90px] items-start">
            {button}
        </div>
    </>
}
